var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product_footer",attrs:{"data-aos-delay":"50"}},[_c('img',{attrs:{"src":require("@/assets/product/产品底部.png")}})])
}]

export { render, staticRenderFns }